import { assert } from '@sama/js-core';
import { ProjectionType } from '../../../cross-team-shared/misc-utils/projection-utils';
import { H3Material } from '../../materials/basic/h3-basic-material';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { getCameraData } from '../calibration-utils';
import { setBrownConradyUniforms } from './vertex-shaders/brown-conrady-projection';
import { setCylindricalUniforms } from './vertex-shaders/cylindrical-projection';
import { setFisheyeUniforms } from './vertex-shaders/fisheye-projection';
import { setLutUniforms } from './vertex-shaders/lut-projection';

export interface ProjectionUniformsParams {
  state: PointCloudContentState;
  projectionType: ProjectionType;
  currentOutputName: string;
  name?: string;
}

// eslint-disable-next-line max-lines-per-function, complexity -- ok for switch statements
export function setProjectionUniforms(
  material: H3Material,
  { state, projectionType, currentOutputName }: ProjectionUniformsParams,
) {
  const currentFrameCalibrationData = getCameraData(
    state.calibrationData[currentOutputName],
    state.render.calibrationOptions[currentOutputName],
    state.render.frameNumber,
  );
  const imageSize = state.projectionImageSize[currentOutputName];
  assert(imageSize, 'Image size should be defined for a defined output');
  material.setUniform('imageSize', imageSize);

  switch (projectionType) {
    case 'pinhole':
      break;

    case 'lut':
      setLutUniforms(material, {
        lutData: state.render.lutData,
        originalCalibrationData: state.calibrationData[currentOutputName],
        currentFrameCalibrationData,
      });
      break;

    case 'cylinder':
    case 'deformed_cylindrical':
      setCylindricalUniforms(material, {
        currentFrameCalibrationData,
      });
      break;
    case 'brown_conrady':
      setBrownConradyUniforms(material, {
        currentFrameCalibrationData,
      });
      break;

    case 'kannala_brandt':
      setFisheyeUniforms(material, {
        currentFrameCalibrationData,
      });
      break;

    default:
      throw new Error(`Unsupported projection method ${projectionType}`);
  }
}

export function assignProjectionDefines(
  material: H3Material,
  projectionType: ProjectionType,
) {
  material.assignDefines({
    USE_LUT_PROJECTION: projectionType === 'lut',
    USE_FISHEYE_PROJECTION: projectionType === 'kannala_brandt',
    USE_CYLINDRICAL_PROJECTION: projectionType === 'cylinder',
    USE_DEFORMED_CYLINDRICAL_PROJECTION:
      projectionType === 'deformed_cylindrical',
    USE_BROWN_CONRADY_PROJECTION: projectionType === 'brown_conrady',
  });
}
